import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { expVal } from '@confluence/feature-experiments';

interface UseEnrolledAIInEditorModalsExperimentProps {
	touchpoint: 'ai-in-editor' | 'end-of-trial';
	isEligible: boolean;
	extraAnalyticsAttributes?: object;
}

export const useEnrolledAIInEditorModalsExperiment = ({
	touchpoint,
	isEligible,
	extraAnalyticsAttributes = {},
}: UseEnrolledAIInEditorModalsExperimentProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const experimentValues = useMemo(() => {
		if (!isEligible) {
			return {
				isABTreatment: false,
			};
		}

		if (
			expVal('twcg-530_confluence_ai_in_editor_eot_aa', 'cohort', 'not-enrolled') !== 'not-enrolled'
		) {
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					action: 'exposed',
					actionSubject: 'experiment',
					actionSubjectId: `twcg-530_confluence_ai_in_editor_eot_aa-exposed`,
					attributes: {
						cohort: expVal('twcg-530_confluence_ai_in_editor_eot_aa', 'cohort', 'not-enrolled'),
						touchpoint,
						...extraAnalyticsAttributes,
					},
					source: 'twcg-530_confluence_ai_in_editor_eot_aa',
				},
			}).fire();
		}

		if (
			expVal('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled'
		) {
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					action: 'exposed',
					actionSubject: 'experiment',
					actionSubjectId: `twcg-530_confluence_ai_in_editor_eot-exposed`,
					attributes: {
						cohort: expVal('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled'),
						touchpoint,
						...extraAnalyticsAttributes,
					},
					source: 'twcg-530_confluence_ai_in_editor_eot',
				},
			}).fire();
			return {
				isABTreatment:
					expVal('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') === 'treatment',
			};
		}

		return {
			isABTreatment: false,
		};
		// Using primitives for dependencies to avoid unnecessary re-renders
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEligible, touchpoint, extraAnalyticsAttributes]);

	return experimentValues;
};
